import React from 'react';
import {PageContent} from '@genestack/ui';
import styles from '../right-panel.module.css';

interface Props {
    searchString: string;
}

export function NothingFoundView(props: Props) {
    return (
        <PageContent>
            <div className={styles.nothingFoundView}>No results for "{props.searchString}"</div>
        </PageContent>
    );
}
